<template>
<el-date-picker
  :value="value"
  type="daterange"
  range-separator="-"
  start-placeholder="开始日期"
  end-placeholder="结束日期"
  @change="changeHandler"
/>
</template>

<script>
export default {
  name: 'DatePicker',
  props: ['value', 'widget'],
  computed: {
    props () {
      return this.widget.props;
    },
  },
  methods: {
    changeHandler (newValue) {
      this.$emit('change', newValue);
    },
  },
};
</script>

<style scoped>
.time-select-range-start {
  margin-right: 10px;
}
</style>
